<div [formGroup]="formMode">
  <div class="row">
    <div class="col-md-12 col-lg-9">
      <h2 class="cx-checkout-title d-none d-lg-block d-xl-block">
        {{ 'checkoutShipping.shippingMethod' | cxTranslate }}
      </h2>

      <ng-container *ngIf="(supportedDeliveryModes$ | async)?.length; else loading">
        <div class="form-check" *ngFor="let mode of supportedDeliveryModes$ | async">
          <input
            class="form-check-input"
            role="radio"
            type="radio"
            id="deliveryMode-{{ mode.code }}"
            [attr.aria-checked]="isSelected(mode) ? 'true' : 'false'"
            (change)="changeMode(mode)"
            [value]="mode"
            formControlName="deliveryModeId"
          />
          <label class="cx-delivery-label form-check-label form-radio-label" for="deliveryMode-{{ mode.code }}">
            <div class="cx-delivery-mode">{{ mode.name }}</div>
            <div class="cx-delivery-price">
              {{ mode.deliveryCost?.formattedValue }}
            </div>
            <div class="cx-delivery-details">{{ mode.description }}</div>
            <div *ngIf="mode.isClickAndCollectMode">
              <div *ngFor="let item of mode.clickAndCollectLocations" class="collect-location">
                <input
                  class="location-input"
                  type="radio"
                  role="radio"
                  name="{{ mode.code }}-collectLocation"
                  [value]="item"
                  (change)="onCollectLocationSelectionChange(item)"
                  formControlName="{{ mode.code }}-collectLocation"
                />
                <label class="location-label">{{ item }}</label>
              </div>
            </div>
          </label>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="!continueButtonPressed; else loading">
    <div class="flex-container">
      <div class="flex-item">
        <button class="btn btn-block btn-action" (click)="back()">
          {{ backBtnText | cxTranslate }}
        </button>
      </div>
      <div class="flex-item">
        <button class="btn btn-block btn-primary" [disabled]="deliveryModeInvalid" (click)="next()">
          {{ 'common.continue' | cxTranslate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
